import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../classes/api-response';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoxInterface } from "../model/box-interface";
import { Constants } from "../utils/constants";
import { AssignBoxInterfaceDTO } from '../model/dto/box-interface/assign-box-interface.dto';
import { CreateBoxInterfaceDTO } from '../model/dto/box-interface/create-box-interface.dto';
import { UpdateBoxInterfaceDTO } from '../model/dto/box-interface/update-box-interface.dto';


@Injectable({
  providedIn: 'root'
})
export class BoxInterfacesService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = 'box-interfaces';
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllBoxInterfaces(): Observable<BoxInterface[]> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`)
      .pipe(map(value => value.data as BoxInterface[]));
  }

  public getBoxInterface(id?: number): Observable<BoxInterface[]> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(value => value.data as BoxInterface[]));
  }

  public createBoxInterface(boxInterface: CreateBoxInterfaceDTO): Observable<BoxInterface> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, boxInterface)
      .pipe(map(value => value.data as BoxInterface));
  }

  public updateBoxInterface(id: number, boxInterface: UpdateBoxInterfaceDTO): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${id}`, boxInterface)
      .pipe(map(() => { }));
  }

  public deleteBoxInterface(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public associateBoxInterfaces(boxId?: number, boxInterfaces?: AssignBoxInterfaceDTO): Observable<void> {
    return this.http
      .put<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.crtlPathFragment}`, boxInterfaces)
      .pipe(map(() => { }));
  }

  public getBoxInterfacesByBox(boxId?: number): Observable<BoxInterface[]> {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/box-interfaces`)
      .pipe(map(value => value.data as BoxInterface[]));
  }

  public deleteBoxInterfaceAssociation(boxId: number, interfaceId?: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.crtlPathFragment}/${interfaceId}`)
      .pipe(map(() => { }));
  }


}
